import { render, staticRenderFns } from "./userDetailsDialog.vue?vue&type=template&id=597bca08"
import script from "./userDetailsDialog.vue?vue&type=script&lang=js"
export * from "./userDetailsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports